// The takeover-risk hover's data — "risk from scaling to TED-AI in this
// year", Joanna's table (2026-07-09), monthly granularity kept verbatim.
// P(takeover) 0..1 by (fractional) year. Shared by the HUD's risk-area hover
// details (capabilityHoverSwap.tsx) and the graph's foom-preview overlay
// (RiskFoomPreviewOverlay.tsx) — one source, no drift.

import {
  CAPABILITY_STAGE_LADDERS,
  capabilityMilestones,
  capabilityStageScaleForPlan,
} from "./capabilityThresholds"

// One point of the takeover-risk curve. `year` may be fractional; `value` is
// a 0..1 fraction.
export type RiskAreaLikelihoodPoint = { year: number; value: number }

export const TAKEOVER_RISK_LIKELIHOOD_DATA: RiskAreaLikelihoodPoint[] = [
  { year: 2025.0, value: 0.85 },
  { year: 2025.0833, value: 0.85 },
  { year: 2025.1667, value: 0.85 },
  { year: 2025.25, value: 0.85 },
  { year: 2025.3333, value: 0.85 },
  { year: 2025.4167, value: 0.85 },
  { year: 2025.5, value: 0.85 },
  { year: 2025.5833, value: 0.85 },
  { year: 2025.6667, value: 0.85 },
  { year: 2025.75, value: 0.85 },
  { year: 2025.8333, value: 0.85 },
  { year: 2025.9167, value: 0.85 },
  { year: 2026.0, value: 0.85 },
  { year: 2026.0833, value: 0.85 },
  { year: 2026.1667, value: 0.85 },
  { year: 2026.25, value: 0.85 },
  { year: 2026.3333, value: 0.85 },
  { year: 2026.4167, value: 0.85 },
  { year: 2026.5, value: 0.85 },
  { year: 2026.5833, value: 0.85 },
  { year: 2026.6667, value: 0.85 },
  { year: 2026.75, value: 0.85 },
  { year: 2026.8333, value: 0.85 },
  { year: 2026.9167, value: 0.85 },
  { year: 2027.0, value: 0.85 },
  { year: 2027.0833, value: 0.85 },
  { year: 2027.1667, value: 0.85 },
  { year: 2027.25, value: 0.85 },
  { year: 2027.3333, value: 0.85 },
  { year: 2027.4167, value: 0.85 },
  { year: 2027.5, value: 0.85 },
  { year: 2027.5833, value: 0.85 },
  { year: 2027.6667, value: 0.85 },
  { year: 2027.75, value: 0.85 },
  { year: 2027.8333, value: 0.85 },
  { year: 2027.9167, value: 0.85 },
  { year: 2028.0, value: 0.85 },
  { year: 2028.0833, value: 0.85 },
  { year: 2028.1667, value: 0.85 },
  { year: 2028.25, value: 0.85 },
  { year: 2028.3333, value: 0.85 },
  { year: 2028.4167, value: 0.85 },
  { year: 2028.5, value: 0.85 },
  { year: 2028.5833, value: 0.85 },
  { year: 2028.6667, value: 0.85 },
  { year: 2028.75, value: 0.85 },
  { year: 2028.8333, value: 0.85 },
  { year: 2028.9167, value: 0.85 },
  { year: 2029.0, value: 0.85 },
  { year: 2029.0833, value: 0.8479 },
  { year: 2029.1667, value: 0.8458 },
  { year: 2029.25, value: 0.8438 },
  { year: 2029.3333, value: 0.8417 },
  { year: 2029.4167, value: 0.8396 },
  { year: 2029.5, value: 0.8375 },
  { year: 2029.5833, value: 0.8354 },
  { year: 2029.6667, value: 0.8333 },
  { year: 2029.75, value: 0.8312 },
  { year: 2029.8333, value: 0.8292 },
  { year: 2029.9167, value: 0.8271 },
  { year: 2030.0, value: 0.825 },
  { year: 2030.0833, value: 0.8229 },
  { year: 2030.1667, value: 0.8208 },
  { year: 2030.25, value: 0.8188 },
  { year: 2030.3333, value: 0.8167 },
  { year: 2030.4167, value: 0.8146 },
  { year: 2030.5, value: 0.8125 },
  { year: 2030.5833, value: 0.8104 },
  { year: 2030.6667, value: 0.8083 },
  { year: 2030.75, value: 0.8062 },
  { year: 2030.8333, value: 0.8042 },
  { year: 2030.9167, value: 0.8021 },
  { year: 2031.0, value: 0.8 },
  { year: 2031.0833, value: 0.7979 },
  { year: 2031.1667, value: 0.7958 },
  { year: 2031.25, value: 0.7938 },
  { year: 2031.3333, value: 0.7917 },
  { year: 2031.4167, value: 0.7896 },
  { year: 2031.5, value: 0.7875 },
  { year: 2031.5833, value: 0.7854 },
  { year: 2031.6667, value: 0.7833 },
  { year: 2031.75, value: 0.7812 },
  { year: 2031.8333, value: 0.7792 },
  { year: 2031.9167, value: 0.7771 },
  { year: 2032.0, value: 0.775 },
  { year: 2032.0833, value: 0.7729 },
  { year: 2032.1667, value: 0.7708 },
  { year: 2032.25, value: 0.7688 },
  { year: 2032.3333, value: 0.7667 },
  { year: 2032.4167, value: 0.7646 },
  { year: 2032.5, value: 0.7625 },
  { year: 2032.5833, value: 0.7604 },
  { year: 2032.6667, value: 0.7583 },
  { year: 2032.75, value: 0.7562 },
  { year: 2032.8333, value: 0.7542 },
  { year: 2032.9167, value: 0.7521 },
  { year: 2033.0, value: 0.75 },
  { year: 2033.0833, value: 0.7417 },
  { year: 2033.1667, value: 0.7333 },
  { year: 2033.25, value: 0.725 },
  { year: 2033.3333, value: 0.7167 },
  { year: 2033.4167, value: 0.7083 },
  { year: 2033.5, value: 0.7 },
  { year: 2033.5833, value: 0.6917 },
  { year: 2033.6667, value: 0.6833 },
  { year: 2033.75, value: 0.675 },
  { year: 2033.8333, value: 0.6667 },
  { year: 2033.9167, value: 0.6583 },
  { year: 2034.0, value: 0.65 },
  { year: 2034.0833, value: 0.6417 },
  { year: 2034.1667, value: 0.6333 },
  { year: 2034.25, value: 0.625 },
  { year: 2034.3333, value: 0.6167 },
  { year: 2034.4167, value: 0.6083 },
  { year: 2034.5, value: 0.6 },
  { year: 2034.5833, value: 0.5917 },
  { year: 2034.6667, value: 0.5833 },
  { year: 2034.75, value: 0.575 },
  { year: 2034.8333, value: 0.5667 },
  { year: 2034.9167, value: 0.5583 },
  { year: 2035.0, value: 0.55 },
  { year: 2035.0833, value: 0.5417 },
  { year: 2035.1667, value: 0.5333 },
  { year: 2035.25, value: 0.525 },
  { year: 2035.3333, value: 0.5167 },
  { year: 2035.4167, value: 0.5083 },
  { year: 2035.5, value: 0.5 },
  { year: 2035.5833, value: 0.4917 },
  { year: 2035.6667, value: 0.4833 },
  { year: 2035.75, value: 0.475 },
  { year: 2035.8333, value: 0.4667 },
  { year: 2035.9167, value: 0.4583 },
  { year: 2036.0, value: 0.45 },
  { year: 2036.0833, value: 0.4417 },
  { year: 2036.1667, value: 0.4333 },
  { year: 2036.25, value: 0.425 },
  { year: 2036.3333, value: 0.4167 },
  { year: 2036.4167, value: 0.4083 },
  { year: 2036.5, value: 0.4 },
  { year: 2036.5833, value: 0.3917 },
  { year: 2036.6667, value: 0.3833 },
  { year: 2036.75, value: 0.375 },
  { year: 2036.8333, value: 0.3667 },
  { year: 2036.9167, value: 0.3583 },
  { year: 2037.0, value: 0.35 },
  { year: 2037.0833, value: 0.3367 },
  { year: 2037.1667, value: 0.3233 },
  { year: 2037.25, value: 0.31 },
  { year: 2037.3333, value: 0.2967 },
  { year: 2037.4167, value: 0.2833 },
  { year: 2037.5, value: 0.27 },
  { year: 2037.5833, value: 0.2567 },
  { year: 2037.6667, value: 0.2433 },
  { year: 2037.75, value: 0.23 },
  { year: 2037.8333, value: 0.2167 },
  { year: 2037.9167, value: 0.2033 },
  { year: 2038.0, value: 0.19 },
  { year: 2038.0833, value: 0.1767 },
  { year: 2038.1667, value: 0.1633 },
  { year: 2038.25, value: 0.15 },
  { year: 2038.3333, value: 0.1367 },
  { year: 2038.4167, value: 0.1233 },
  { year: 2038.5, value: 0.11 },
  { year: 2038.5833, value: 0.0967 },
  { year: 2038.6667, value: 0.0833 },
  { year: 2038.75, value: 0.07 },
  { year: 2038.8333, value: 0.0567 },
  { year: 2038.9167, value: 0.0433 },
  { year: 2039.0, value: 0.03 },
  { year: 2039.0833, value: 0.0292 },
  { year: 2039.1667, value: 0.0283 },
  { year: 2039.25, value: 0.0275 },
  { year: 2039.3333, value: 0.0267 },
  { year: 2039.4167, value: 0.0258 },
  { year: 2039.5, value: 0.025 },
  { year: 2039.5833, value: 0.0242 },
  { year: 2039.6667, value: 0.0233 },
  { year: 2039.75, value: 0.0225 },
  { year: 2039.8333, value: 0.0217 },
  { year: 2039.9167, value: 0.0208 },
  { year: 2040.0, value: 0.02 },
  { year: 2040.0833, value: 0.0192 },
  { year: 2040.1667, value: 0.0183 },
  { year: 2040.25, value: 0.0175 },
  { year: 2040.3333, value: 0.0167 },
  { year: 2040.4167, value: 0.0158 },
  { year: 2040.5, value: 0.015 },
  { year: 2040.5833, value: 0.0142 },
  { year: 2040.6667, value: 0.0133 },
  { year: 2040.75, value: 0.0125 },
  { year: 2040.8333, value: 0.0117 },
  { year: 2040.9167, value: 0.0108 },
  { year: 2041.0, value: 0.01 },
]

// The chart's yearly view of the table ("show it yearly") — one bar per
// integer year.
export const TAKEOVER_RISK_YEARLY_POINTS = TAKEOVER_RISK_LIKELIHOOD_DATA.filter(
  point => Math.abs(point.year - Math.round(point.year)) < 1e-6,
)

// The risk regimes the hover details ladder through, with layperson
// one-liners. `matches` picks the highlighted/labeled regime for a given
// likelihood fraction.
export type RiskLevelLadderEntry = {
  label: string
  range: string
  description: string
  matches: (riskFraction: number) => boolean
}

export const TAKEOVER_RISK_LEVEL_LADDER: RiskLevelLadderEntry[] = [
  {
    label: "Negligible Risk",
    range: "~0%",
    description: "Alignment techniques are good enough that a rapid scale-up would stay under human control.",
    matches: (riskFraction) => riskFraction <= 0,
  },
  {
    label: "Low Risk",
    range: "<10%",
    description: "A rapid scale-up would probably go fine, with real residual risk.",
    matches: (riskFraction) => riskFraction > 0 && riskFraction < 0.1,
  },
  {
    label: "Moderate Risk",
    range: "10–20%",
    description: "A meaningful chance that a scaled-up AI escapes human control.",
    matches: (riskFraction) => riskFraction >= 0.1 && riskFraction < 0.2,
  },
  {
    label: "High Risk",
    range: "20–40%",
    description: "Scaling now is a serious gamble with humanity's future.",
    matches: (riskFraction) => riskFraction >= 0.2 && riskFraction < 0.4,
  },
  {
    label: "Very High Risk",
    range: "40%+",
    description: "Near-even or worse odds that scaling now hands the future to AIs we cannot steer.",
    matches: (riskFraction) => riskFraction >= 0.4,
  },
]

// The EXTENDED ladder (2026-07-13): the story's early years sit at 85%, so
// the 40%+ top bucket pinned the highlight for half the timeline — this
// split adds resolution above it (75%+, 50–75%, 40–50%, per Joanna's
// bands). The lower four rows mirror the base ladder verbatim (kept as
// literals here so every row is one cmd-click away). DRAFT copy on the new
// bands — edit freely.
export const TAKEOVER_RISK_LEVEL_LADDER_EXTENDED: RiskLevelLadderEntry[] = [
  {
    label: "Negligible Risk",
    range: "~0%",
    description: "Alignment techniques are good enough that a rapid scale-up would stay under human control.",
    matches: (riskFraction) => riskFraction <= 0,
  },
  {
    label: "Low Risk",
    range: "<10%",
    description: "A rapid scale-up would probably go fine, with real residual risk.",
    matches: (riskFraction) => riskFraction > 0 && riskFraction < 0.1,
  },
  {
    label: "Moderate Risk",
    range: "10–20%",
    description: "A meaningful chance that a scaled-up AI escapes human control.",
    matches: (riskFraction) => riskFraction >= 0.1 && riskFraction < 0.2,
  },
  {
    label: "High Risk",
    range: "20–40%",
    description: "Scaling now is a serious gamble with humanity's future.",
    matches: (riskFraction) => riskFraction >= 0.2 && riskFraction < 0.4,
  },
  {
    label: "Very High Risk",
    range: "40–50%",
    description: "Near-even odds that scaling now hands the future to AIs we cannot steer.",
    matches: (riskFraction) => riskFraction >= 0.4 && riskFraction < 0.5,
  },
  {
    label: "Severe Risk",
    range: "50%+",
    description: "More likely than not that a scaled-up AI ends up beyond human control.",
    matches: (riskFraction) => riskFraction >= 0.5 && riskFraction < 0.75,
  },
  {
    label: "Extreme Risk",
    range: "75%+",
    description: "Scaling now almost certainly hands the future to AIs we cannot steer.",
    matches: (riskFraction) => riskFraction >= 0.75,
  },
]

// The regime label for a likelihood fraction (the foom preview's "level"
// readout and the ladder's highlighted row agree by construction).
export const riskLevelLabelForLikelihood = (riskFraction: number): string =>
  TAKEOVER_RISK_LEVEL_LADDER.find(level => level.matches(riskFraction))?.label ??
  TAKEOVER_RISK_LEVEL_LADDER[TAKEOVER_RISK_LEVEL_LADDER.length - 1].label

// Linear interpolation of the (sorted-by-year) curve at a fractional year,
// clamped to the table's domain. Null only for an empty table.
export const likelihoodAtYear = (
  points: RiskAreaLikelihoodPoint[],
  year: number,
): number | null => {
  if (points.length === 0) return null
  const clamped = Math.min(Math.max(year, points[0].year), points[points.length - 1].year)
  for (let i = 1; i < points.length; i++) {
    if (points[i].year >= clamped) {
      const a = points[i - 1]
      const b = points[i]
      const f = b.year === a.year ? 0 : (clamped - a.year) / (b.year - a.year)
      return a.value + (b.value - a.value) * f
    }
  }
  return points[points.length - 1].value
}

export const fmtLikelihood = (v: number) => {
  if (v > 0 && v < 0.01) return "<1%"
  return `${Math.round(v * 100)}%`
}

// ─── Risk at an arbitrary capability level ───────────────────────────────────
// Joanna's table is authored AT the Top-Expert-Dominating level; other
// levels scale the year's TED value by the level's ladder position relative
// to TED, capped at 100%. The position is FRACTIONAL, log-interpolated from
// the capability VALUE between the same per-plan thresholds the ladder
// labels use (whole-rung steps made the number sawtooth: within a rung the
// table's slow year-decline dragged it down — 34% → 33% — before the next
// rung jumped it back up; the fractional rung climbs with the line itself).
// TED in 2031 reads the table's 2031 value (80%) exactly; the display
// ladder's row order is capabilityMilestones' first seven entries.
export const CURRENT_LEVEL_RISK_TED_LABEL = "Top-Expert-Dominating AI"

// How the TED value scales DOWN the ladder: (position / TED-position) ^
// exponent — zero at the ladder's very bottom, the table's value at TED.
// The exponent bows the curve so the low rungs read near-negligible
// (Joanna 2026-07-13: an earlier linear-with-floor take showed 17–34% for
// Unreliable/Reliable-Agent heights in 2025 — way too high). At 2 the 2025
// column read ~0% / 5% / 21% / 48% / 85% up the rungs; Joanna 2026-07-15
// ("a lot lower at the beginning"): 3 reads ~0% / 2% / 11% / 36% / 85%.
export const CURRENT_LEVEL_RISK_SCALING = {
  exponent: 3,
}
export const currentLevelRiskAt = (
  capabilityValue: number,
  plan: string | null | undefined,
  year: number,
): number | null => {
  const tedRisk = likelihoodAtYear(TAKEOVER_RISK_LIKELIHOOD_DATA, year)
  if (tedRisk === null || !(capabilityValue > 0)) return null
  const ladderIndexForLabel = (label: string) =>
    capabilityMilestones.findIndex((milestone) => milestone.label === label)
  // The (ladder-index, threshold-value) knots: the two pre-AC milestones
  // plus the plan's stage ladder — Plan A's ladder skips Superhuman AI
  // Researcher, so its AC→TED stretch spans two ladder rows, exactly like
  // the labels do.
  const knots: { index: number; value: number }[] = [
    { index: 0, value: capabilityMilestones[0].value },
    { index: 1, value: capabilityMilestones[1].value },
    ...CAPABILITY_STAGE_LADDERS[capabilityStageScaleForPlan(plan)].flatMap(
      (stage) => {
        const index = ladderIndexForLabel(stage.label)
        return index === -1 ? [] : [{ index, value: stage.atOrAbove }]
      },
    ),
  ]
  const tedIndex = ladderIndexForLabel(CURRENT_LEVEL_RISK_TED_LABEL)
  if (knots.length < 2 || tedIndex === -1) return null
  // Log-interpolate the value between its bracketing knots, clamped to the
  // ladder's ends.
  let fractionalIndex = knots[knots.length - 1].index
  if (capabilityValue <= knots[0].value) {
    fractionalIndex = knots[0].index
  } else {
    for (let i = 1; i < knots.length; i++) {
      if (capabilityValue <= knots[i].value) {
        const a = knots[i - 1]
        const b = knots[i]
        const t =
          Math.log(capabilityValue / a.value) / Math.log(b.value / a.value)
        fractionalIndex = a.index + (b.index - a.index) * t
        break
      }
    }
  }
  return Math.min(
    1,
    tedRisk *
      Math.max(0, fractionalIndex / tedIndex) ** CURRENT_LEVEL_RISK_SCALING.exponent,
  )
}
